import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';

function EditCashierTypeDialog({
  visible,
  order,
  onHide,
  onCashierTypeSaved
}) {
 
  // #region vars and consts

  const [cashierOrder, setCashierOrder] = useState(null);
  const [cashierTypes, setCashierTypes] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [detailTypes, setDetailTypes] = useState([]);
  const [cashierType, setCashierType] = useState(null);
  const [reason, setReason] = useState(null);
  const [detailType, setDetailType] = useState(null);

  // #endregion

  // #region events

  useEffect(() => {        
    if (visible && order) {            
      getCashierOrder(order.orderId);
    }
  }, [order, visible]);

  const onHideDialog = () => {
    hideDialog();
  };

  const onCashierTypeChange = (e) => {
    console.log('onCashierTypeChange', e.value);
    resetReasons();
    const _cashierType = e.value;
    setCashierType(_cashierType);
    getReasons(_cashierType.cashierTypeId);    
  };

  const onReasonChange = (e) => {
    resetDetailTypes();
    const _reason = e.value;
    setReason(_reason);    
    getDetailTypes(_reason.cashierTypeId);
  };

  const onDetailTypeChange = (e) => {
    setDetailType(e.value);
  };

  const onSaveClick = (e) => {
    save(
      order.orderId,
      cashierType.cashierTypeId,
      reason.cashierTypeId,
      detailType.cashierTypeId
    );
  };

  // #endregion

  // #region methods

  const hideDialog = () => {
    if (onHide) onHide();
  };

  const reset = () => {
    resetCashierTypes();
  };

  const resetCashierTypes = () => {
    setCashierTypes([]);
    setCashierType(null);
    resetReasons();
    resetDetailTypes();
  };

  const resetReasons = () => {
    setReasons([]);
    setDetailTypes([]);
    resetDetailTypes();
  };

  const resetDetailTypes = () => {    
    setDetailTypes([]);    
    setDetailType(null);
  };

  const getCashierOrder = (orderId) => {    
    fetch(`${process.env.REACT_APP_API_URL}/cashierOrder/findByOrder?orderId=${orderId}`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const cashierOrder = data.responseObject;
          setCashierOrder(cashierOrder);
          getCashierTypes(cashierOrder.cashierTypeIdL0, cashierOrder.cashierTypeIdL1, cashierOrder.cashierTypeIdL2);
        } else {
          console.warn('Error getting cashier order');
        }
      });
  };

  const getCashierTypes = (cashierTypeIdToSelect, reasonIdToSelect, detailTypeIdToSelect) => {
    reset();
    fetch(`${process.env.REACT_APP_API_URL}/cashierType/cmbLevel0`)      
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _cashierTypes = data.responseObject;
          setCashierTypes(_cashierTypes);
          setupCashierType(_cashierTypes, cashierTypeIdToSelect, reasonIdToSelect, detailTypeIdToSelect);
        } else {
          console.warn('Error getting cashier types');
        }
      });
  };

  const setupCashierType = (cashierTypes, cashierTypeIdToSelect, reasonIdToSelect, detailTypeIdToSelect) => {
    if (Array.isArray(cashierTypes)) {
      const filterdCashierTypes = cashierTypes.filter((cashierType) => {
        return cashierType.cashierTypeId === cashierTypeIdToSelect;
      });
      if (filterdCashierTypes.length > 0) {
        const cashierType = filterdCashierTypes[0];          
        setCashierType(cashierType);
        getReasons(cashierType.cashierTypeId, reasonIdToSelect, detailTypeIdToSelect);
      }
    }    
  };

  const getReasons = (cashierTypeId, reasonIdToSelect, detailTypeIdToSelect) => {
    fetch(`${process.env.REACT_APP_API_URL}/cashierType/cmbLevelN?cashierTypeId=${cashierTypeId}`)      
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _reasons = data.responseObject;
          setReasons(_reasons);
          setupReason(_reasons, reasonIdToSelect, detailTypeIdToSelect);
        } else {
          console.warn('Error getting reasons');
        }
      });
  };

  const setupReason = (reasons, reasonId, detailTypeIdToSelect) => {
    if (Array.isArray(reasons)) {
      const filterdReasons = reasons.filter((reason) => {
        return reason.cashierTypeId === reasonId;
      });
      if (filterdReasons.length > 0) {
        const reason = filterdReasons[0];
        setReason(reason);
        getDetailTypes(reason.cashierTypeId, detailTypeIdToSelect)
      }
    }
  };  

  const getDetailTypes = (reasonId, detailTypeIdToSelect) => {
    fetch(`${process.env.REACT_APP_API_URL}/cashierType/cmbLevelN?cashierTypeId=${reasonId}`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _detailTypes = data.responseObject;
          setDetailTypes(_detailTypes);
          setupDetailType(_detailTypes, detailTypeIdToSelect);
        } else {
          console.warn('Error getting detail types');
        }
      });
  };

  const setupDetailType = (detailTypes, detailTypeId) => {
    if (Array.isArray(detailTypes)) {
      const filterdDetailTypes = detailTypes.filter((detailType) => {
        return detailType.cashierTypeId === detailTypeId;
      });
      if (filterdDetailTypes.length > 0) {
        setDetailType(filterdDetailTypes[0]);
      }
    }
  };  

  const save = (
    orderId,
    cashierTypeIdL0,
    cashierTypeIdL1,
    cashierTypeIdL2
  ) => {
    fetch(`${process.env.REACT_APP_API_URL}/cashierOrder/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId,
        cashierTypeIdL0,
        cashierTypeIdL1,
        cashierTypeIdL2
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {        
        onCashierTypeSaved();
      } else {
        console.log("Error saving cashier type.");
      }
    });
  };

  // #endregion

  // #region templates

  const cashierTypeFormItemTemplate = (
    <>
      <div className='grid'>
        <div className='col'>
          <label
            className='d-block'
            htmlFor="cashierType"
          >
            Estado de caja
          </label>
          <Dropdown
            name='cashierType'
            value={cashierType}
            options={cashierTypes}
            onChange={onCashierTypeChange}
            optionLabel="description"
            placeholder="Selecciona un estado de caja"
            className='w-100'
          />
        </div>
      </div>
    </>
  );

  const reasonFormItemTemplate = (
    <>
      {
        Array.isArray(reasons) && reasons.length > 0 && (
          <div className='grid'>
            <div className='col'>
              <label
                className='d-block'
                htmlFor="reason"
              >
                Razón
              </label>
              <Dropdown
                name='reason'
                value={reason}
                options={reasons}
                onChange={onReasonChange}
                optionLabel="description"
                placeholder="Selecciona una razón"
                className='w-100'
              />
            </div>
          </div>
        )
      }
    </>
  );

  const detailTypeFormItemTemplate = (
    <>
      {
        Array.isArray(detailTypes) && detailTypes.length > 0 && (
          <div className='grid'>
            <div className='col'>
              <label
                className='d-block'
                htmlFor="detailType"
              >
                Detalle
              </label>
              <Dropdown
                name='detailType'
                value={detailType}
                options={detailTypes}
                onChange={onDetailTypeChange}
                optionLabel="description"
                placeholder="Selecciona un detalle"
                className='w-100'
              />
            </div>
          </div>  
        )
      }
    </>
  );

  const formTemplate = (
    <>
      <div className='grid'>
        <div className='col'>
          {cashierTypeFormItemTemplate}
        </div>
      </div>
      <div className='grid'>
        <div className='col'>
          {reasonFormItemTemplate}
        </div>
      </div>
      <div className='grid'>
        <div className='col'>
          {detailTypeFormItemTemplate}
        </div>
      </div>
      <div className='grid'>
        <div className='col text-end'>
          <Button
            type="submit"
            label="Guardar"
            className="p-button-raised p-button-sm mt-2"
            disabled={!cashierType}
            onClick={onSaveClick}
          />  
        </div>
      </div>    
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header="Editar Estado de Caja"
        visible={visible}
        onHide={onHideDialog}                
        style={{ width: '40vw' }}        
      >
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default EditCashierTypeDialog;